import { removeComposeLinkViewState } from '../actions/internalActions';
import { addComposeLinkViewState, removeAllComposeLinkViewStates } from '../actions/publicActions';
import ComposeLinkViewState from '../store/schema/ComposeLinkViewState';
import getStore from '../store/store';
import { mutator } from 'satcheljs';

mutator(addComposeLinkViewState, actionMessage => {
    const store = getStore();
    const composeLinkViewState: ComposeLinkViewState = {
        linkId: actionMessage.linkId,
        isContextMenuOpen: false,
        isLinkBeautified: false,
        displayName: null,
    };

    store.composeLinks.set(actionMessage.linkId, composeLinkViewState);
});

mutator(removeComposeLinkViewState, actionMessage => {
    const store = getStore();
    store.composeLinks.delete(actionMessage.linkId);
});

mutator(removeAllComposeLinkViewStates, actionMessage => {
    const store = getStore();
    store.composeLinks.clear();
});
